import React, { useState, useEffect } from 'react';
import { Card, Button, Container, Row, Col } from 'react-bootstrap';
import { storage } from '../../config/fbConfig';
import { Link } from 'react-router-dom';
import { ref, getDownloadURL } from 'firebase/storage';


const ProjectList = ({ projects }) => {
  return (
    <div className="row">
      {projects && projects.map(project => (

        <div key={project.id} className="col-md-6 mb-4">
          <ProjectCard
            projectTitle={project.title}
            projectType={project.projectType}
            projectStartEndDate={`Start: ${project.startDate} / End: ${project.endDate}`}
            logoName={project.projectLogo}
            projectId={project.id}
          />
        </div>
      ))}
    </div>
  )

}

const ProjectCard = ({ projectTitle, projectType, projectStartEndDate, logoName, projectId }) => {
  const [logoUrl, setLogoUrl] = useState('');
  const [isLoading, setIsLoading] = useState(true);

  const logoPathAndFile = 'projects/thumb_' + logoName;

  useEffect(() => {
    // Function to get download URL from Firebase Storage
    const getDownloadUrl = async () => {
      try {
        const imageRef = ref(storage, logoPathAndFile);
        const url = await getDownloadURL(imageRef);

        setLogoUrl(url);
        setIsLoading(false);
      } catch (error) {
        console.error('Error getting download URL:', error);
        setIsLoading(false);
      }
    };

    // Call the function to get download URL when component mounts
    // Call the function to get download URL when component mounts
    if (logoName) {
      getDownloadUrl();
    } else {
      setIsLoading(false);
    }

  }, [logoName]); // Run this effect when logoPath changes

  return (
    <Card style={{ width: '100%', transition: 'transform 0.3s' }}>
      <Card.Body>
        <div className="d-flex">
          <div className="border rounded p-3" style={{ width: '120px', height: '120px', position: 'relative' }}>
            {isLoading && (

              <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
                {isLoading && (
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                )}
              </div>
            )}
            <Card.Img
              variant="top"
              src={logoUrl ? logoUrl : "/imgs/project-logo-placeholder.png"}
              alt={"logo " + projectTitle}
              style={{ width: '100%', height: '100%', display: isLoading ? 'none' : 'block' }} // Hide image while loading
            />
          </div>
          <div className="ms-3">
            <Card.Title>{projectTitle}</Card.Title>
            <Card.Text>
              {projectType}<br />
              {projectStartEndDate}
            </Card.Text>
            <Link to={`/project/${projectId}`}>
              <Button variant="primary">View Details</Button>
            </Link>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};


export default ProjectList